import { ModalLayout, useTranslate } from 'react-gldn-kit';

import ComponentKitBaseButton from 'components/ui/KitComponents/Buttons/BaseButton';
import ReferralTitles from '../ReferralSubTitle';

import { closeAndOpenModalAction } from 'stores/modal/selectors';
import { useZustandModalStore } from 'stores/modal/store';
import { ModalTypes } from 'stores/modal/types';

import styles from './ReferralFailure.module.css';

const ReferralFailure = () => {
  const setModal = useZustandModalStore(closeAndOpenModalAction);

  const { name: title, getText } = useTranslate(
    'referral.failureModal.title',
    ''
  );

  const onCloseModal = () => {
    setModal(ModalTypes.Unknown);
  };

  return (
    <ModalLayout
      classes={styles.wrapperReferralFailure}
      popUpHeaderProps={{
        transparent: true,
        title,
      }}
      buttonClose={onCloseModal}
    >
      <>
        <ReferralTitles subTitle="referral.failureModal.subTitle" />

        <ComponentKitBaseButton
          text="referral.failureModal.ok"
          handleClick={onCloseModal}
          size="--button-full"
          buttonHeight="--button-height-full"
          color="primary"
          centreText
        />
      </>
    </ModalLayout>
  );
};

export default ReferralFailure;
